/*
 * @Description:
 * @Author: 宋信峰
 * @Date: 2022-09-20 15:46:24
 * @LastEditTime: 2022-09-27 18:22:47
 * @LastEditors: 宋信峰
 * @Reference:
 */
import request from "./http";

export function getLqRedirectUrl(data) {
  return request.post("html/user/getLqRedirectUrl", data);
}

export function lists(data = {}) {
  const params = {
    prov_id: data.prov_id || null,
    mold_id: data.mold_id || null,
    mold_ids: data.mold_ids || null,
    is_recommend: data.is_recommend || 0,
    search: data.search || null,
    search_file: data.search_file || null,
    page: data.page || 1,
    page_size: data.page_size || 8,
    store_type: data.store_type || null
  };
  return request.post("html/index/lqShow", params);
}
